import axios from 'axios';

import {
  START_EXAM,
  START_CHALLENGE,
  SAVE_EXAM,
  LIST_EXAM,
  REMOVE_EXAM,
  VIEW_EXAM,
  CLEAR_ERRORS,
  EXAM_LOADING,
  RESET_EXAM
} from './types';

export const listExams = () => dispatch => {
  dispatch(clearErrors());
  axios
    .get(`/api/exam`)
    .then(res =>
      dispatch({
        type: LIST_EXAM,
        payload: res.data
      })
    );
};

export const viewExam = examid => dispatch => {
  dispatch(clearErrors());
  axios
    .get(`/api/exam/${examid}`)
    .then(res =>
      dispatch({
        type: VIEW_EXAM,
        payload: res.data
      })
    );
};

// Add Word
export const startExam = (packid, challenge?) => dispatch => {
  dispatch(clearErrors());
  axios
    .post('/api/exam/create_exam', { packid: packid, challenge: challenge })
    .then(res =>
      dispatch({
        type: START_EXAM,
        payload: res.data
      })
    );
};

export const saveExam = (examId, answers, score?, time?) => dispatch => {
  let examJSON = JSON.stringify(Array.from(answers.entries()));
  let convert = new Map(JSON.parse(examJSON));
  let data = { _id: examId, answers: examJSON, status: 'finish', score: score, time: time };
  axios
    .post('/api/exam/save', data)
    .then(res =>
      dispatch({
        type: SAVE_EXAM,
        payload: res.data
      })
    );
};

// Set loading state
export const setQuestionLoading = () => {
  return {
    type: EXAM_LOADING
  };
};

// Clear errors
export const clearErrors = () => {
  return {
    type: CLEAR_ERRORS
  };
};

export const resetExam = () => {
  return {
    type: RESET_EXAM
  };
};